import { useSelector } from "react-redux";
import {
  getIsUserLoading,
  getUserInformation,
  getUserSettings,
  getDefaultMaxPageRowCount,
} from "./selectors";

export const useUserSettingsData = () => useSelector(getUserSettings);

export const useUserInfoData = () => useSelector(getUserInformation);

export const useIsUserDataLoading = () => useSelector(getIsUserLoading);

export const useDefaultMaxPageRowCount = () =>
  useSelector(getDefaultMaxPageRowCount);
